import React from 'react';
import { motion } from 'framer-motion';

// Elite Components
import SEO from '../components/SEO';
import Hero from '../components/Hero';
import About from '../components/About';
import Services from '../components/Services';
import Treatments from '../components/Treatments';
import Highlights from '../components/Highlights';
import Branches from '../components/Branches';
import ReviewsSection from '../components/ReviewsSection';
import BlogSection from '../components/BlogSection';
import Contact from '../components/Contact';
import MapSection from '../components/MapSection';

const Home = () => {
  return (
    <motion.div
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      exit={{ opacity: 0 }}
      transition={{ duration: 0.8, ease: [0.16, 1, 0.3, 1] }}
    >
      <SEO 
        title="Best Pet Hospital in Vanasthalipuram, Hyderabad"
        description="Searching for a trusted pet hospital in Vanasthalipuram? Get expert veterinary care, surgery, and emergency support at Dr. Suresh Pet Care Hospital."
        canonical="/"
      />
      
      <Hero />
      <div className="relative z-10 bg-background">
        <About />
        <Services />
        <Treatments />
        <Highlights />
        <Branches />
        <ReviewsSection />
        <BlogSection />
        <Contact />
        <MapSection />
      </div>
    </motion.div>
  );
};

export default Home;
